// MGRS readout helpers (wraps the `mgrs` package). WGS84 lat/lon → MGRS.
import { forward } from 'mgrs';

// Raw MGRS at 1 m precision, e.g. "42RUU1234567890".
export function toMGRS(lat: number, lon: number, digits = 5): string {
  try {
    if (!isFinite(lat) || !isFinite(lon)) return '—';
    return forward([lon, lat], digits);
  } catch {
    return '—';
  }
}

// Grouped for display: "42R UU 12345 67890".
export function formatMGRS(lat: number, lon: number): string {
  const raw = toMGRS(lat, lon, 5);
  if (raw === '—') return raw;
  // GZD = digits + one band letter; then 2-letter 100km square; then 2×5-digit.
  const m = raw.match(/^(\d{1,2}[C-X])([A-Z]{2})(\d+)$/);
  if (!m) return raw;
  const [, gzd, sq, num] = m;
  const half = num.length / 2;
  const easting = num.slice(0, half);
  const northing = num.slice(half);
  return `${gzd} ${sq} ${easting} ${northing}`;
}
